import { useRoutes } from 'react-router-dom';
import storage from '../helpers/storage';
import { NotFound } from '../pages/NotFound/NotFound';
import { protectedCustomerRoutes, protectedInspectorRoutes } from './protected';
import { publicRoutes } from './public';
import { CUSTOMER,INSPECTOR } from '../constants/roles';
const basePath = process.env.REACT_APP_BASE_URL;

/**
 * 
 * @returns Routes Elements
 */
export default function AppRoutes() {
    const commonRoutes = [
        {
            path: '*',
            element: <NotFound />,
        }];


    const userInfo = storage.getData('user-info');
    const role = userInfo ? userInfo?.role :'GUEST';
    const protectedRoutes = (role==CUSTOMER)?protectedCustomerRoutes:((role==INSPECTOR)?protectedInspectorRoutes:[]);

    const mainRoutes = (storage.getToken() != null) ? protectedRoutes : [];
    const element = useRoutes([...publicRoutes, ...mainRoutes, ...commonRoutes]);
    return <>{element}</>;
};

